import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PublicPosting } from '../Classes';
import { useTitle, useUser } from '../Hooks';
import { Groupper, Image, Header, Button, Message, Table, Toast, Label, Icon } from 'react-frontier';
import { getDurationTime, getPayRateTypeLocale } from '../Util';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { addCommas, bindClick } from '@tempu/components/Util';
import { GoogleMap, Modal, Card } from '../components';
import API, { CDN_URL } from '../API';
import remarkGfm from 'remark-gfm';
import moment from 'moment';

var Posting = ()=>{
	var params = useParams<{ id: string }>();
	var posting_id = parseInt(params?.id);
	var { user } = useUser();
	var { setTitle } = useTitle();
	var [posting, setPosting] = useState<PublicPosting>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [applicationModal, setApplicationModal] = useState<boolean>(false);
	var [selectedJob, setSelectedJob] = useState<PublicPosting["jobs"][0]>(null);

	useEffect(()=>{
		API.getPublicPosting(posting_id, true).then(res=>{
			if(res.error) return setLoadError(res.message);
			
			setTitle(res.data.posting.posting_name);
			setPosting(res.data.posting);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la oferta de empleo. (LCL-1)');
		})
	}, []);

	var apply = async(setLoading: (l: boolean)=>void)=>{
		setLoading(true);
		API.applyPostingJob(selectedJob.job_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Postulación realizada!')
			
			var p = {...posting};
			p.jobs = p.jobs.map(job => {
			if(job.job_id === selectedJob.job_id){
				return {...job, applied: true};
			}
				return job;
			});
			setPosting(p);
			setApplicationModal(false);
		}).catch(err=>{
			return setModalPrompts(['Hubo un error inesperado al postularse al empleo. (LCL-2)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var openAplicationModal = (job: PublicPosting["jobs"][0]) =>{
		setSelectedJob(job);
		setApplicationModal(true);
		setModalPrompts(null);
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!posting) {
		return <Header loading text='Cargando datos' />;
	}

	return <div className='tp posting-screen'>
		<Card className='masthead' selectable={false}>
			<div className="image">
				<Image src={`${CDN_URL}/posting/${posting.posting_id}/medium.webp`} fallbackComponent={(
					<i className='image icon' />
				)} />
			</div>
			<div className='labels'>
				<div className='name'>{posting.posting_name}</div>
				<div className='name business'>{posting.business_name}</div>
				<div className='description'>
					{!!posting.description ? (
						<ReactMarkdown linkTarget={'_blank'} remarkPlugins={[remarkGfm]} children={posting.description} />
					) : (
						<div style={{ color: 'gray', fontStyle: 'italic' }}>
							El empleo no tiene una descripción
						</div>
					)}
				</div>
			</div>
		</Card>
		<Header text={'Ofertas de empleo'} centered={false} style={{ marginTop: 15, fontSize: 20 }}/>
		{posting.jobs.map(j=>(
			<Card className='job' selectable={false} key={`PSTJ-${j.job_id}`}>
				<div className="header">
					<div className="left">
						<div className="name">{j.job_name}</div>
						<div className="meta">
							<b>${addCommas(j.pay_rate)}</b> · {getPayRateTypeLocale(j.rate_type)}
						</div>
					</div>
					<div className="right">
						{j.available ? (
							!user ? (
								<Button text='Postularse' color='red' as={Link} to={API.getAuthUrl()} />
							) : (
								<Button text={j.applied ?  'Ya postulado' : 'Postularse'} color={!j.applied ? 'red' : null } disabled={j.applied} onClick={() => openAplicationModal(j)} />
							)
						) : (
							<Button disabled text='No disponible' />
						)}
					</div>
				</div>
				<div className="labels">
					<Label>
						<Icon name='calendar' />
						{moment.unix(j.date_start).format('DD/MMM/YY HH:mm')}
					</Label>
					<Label>
						<Icon name='clock' />
						{getDurationTime((j.date_start || posting.date_start), (j.date_end || posting.date_end))}
					</Label>
				</div>
				<div className="description">
					<ReactMarkdown linkTarget={'_blank'} remarkPlugins={[remarkGfm]} children={j.description} />
				</div>
			</Card>
		))}
		<Groupper title={'Ubicación'} className='location'>
			{posting && posting.location?.lattitude ? (
				<GoogleMap className="map-embed" location={posting.location} />
			) : (
				<div className='no-info'>Este empleo no cuenta con ubicación registrada</div>
			)}
		</Groupper>
		<Modal open={applicationModal} onClose={bindClick(setApplicationModal)} size='tiny'>
			<Modal.Header>Postularse a empleo</Modal.Header>
			{selectedJob && <Modal.Content>
				<Header text='¿Postularse a empleo?' subtext={'Se enviará tu solicitud a la empresa contratante y se te notificará cuando se tenga el resultado de tu postulación'} />
				<Table
					details
					striped
					style={{ marginTop: 15, marginBottom: 15 }}
					title='Información de empleo'
					titleSize='small'
					data={[
						['Empleo', posting.posting_name],
						['Puesto', selectedJob.job_name],
						['Fecha inicio', moment.unix(selectedJob.date_start).format('DD/MMM/YY HH:mm')],
						['Tiempo', getDurationTime(selectedJob.date_start, selectedJob.date_end)],
						['Pago', `$${addCommas(selectedJob.pay_rate)} · ${getPayRateTypeLocale(selectedJob.rate_type)}`]
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setApplicationModal)} />
				<Button text='Postularse' color='black' onClick={apply}/>
			</Modal.Actions>
		</Modal>
   </div>
}

export default Posting;